import React from "react";
import {Segment} from "semantic-ui-react";

const MAX_WIDTH = 100;
const MIN_WIDTH = 0;

export default class StretchableSegment extends React.Component {
  constructor() {
    super();
    this.state = {
      resize: false,
      width: 50,
    };
    this.dividerRef = React.createRef();
    this.startResize = this.startResize.bind(this);
    this.stopResize = this.stopResize.bind(this);
  }

  startResize() {
    this.setState({ resize: true });
  }

  stopResize() {
    this.setState({ resize: false });
  }

  resize = (mouseMoveEvent) => {
    if (this.state?.resize) {
      const containerTotalWidth = this.dividerRef.current.parentElement.offsetWidth;
      const relativePosition = mouseMoveEvent.clientX - this.dividerRef.current.parentElement.getBoundingClientRect().left;
      const newWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, Math.round((relativePosition / containerTotalWidth) * 10000) / 100));
      this.setState({ width: newWidth });
    }
  };

  componentDidMount() {
    window.addEventListener("mousemove", this.resize);
    window.addEventListener("mouseup", this.stopResize);
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this.resize);
    window.removeEventListener("mouseup", this.stopResize);
  }

  render() {
    const { leftContainer, rightContainer } = this.props;
    return (
      <Segment className="stretchableSegmentContainer" onMouseDown={(e) => e.preventDefault()}>
        <div className="leftContainer" style={{ width: this.state.width + "%", visibility: this.state.width === 0 ? "hidden" : "visible"}}>
          {leftContainer}
        </div>
        <div className="divider" onMouseDown={this.startResize} ref={this.dividerRef}/>
        <div className="rightContainer" style={{ width: 100 - this.state.width + "%", visibility: this.state.width === 100 ? "hidden" : "visible" }}>
          {rightContainer}
        </div>
      </Segment>
    );
  }
}
